import React from 'react';

import { DataBar } from '@qality/common-components/src/atoms/DataBar';
import { ExecutionStatusSummary } from '@qality/common-model';
import { CssUtils } from '@qality/common-utils';

type Props = {
  statusSummary: ExecutionStatusSummary;
};

export function ExecutionStatusSummaryStackedBarChart({
  statusSummary,
}: Props): JSX.Element {
  return (
    <DataBar.Container>
      {[...statusSummary]
        .sort((a, b) => a.status.position - b.status.position)
        .filter((statusInSummary) => statusInSummary.percent > 0)
        .map((statusInSummary) => (
          <DataBar.Value
            key={statusInSummary.status.id}
            value={statusInSummary.percent}
            color={CssUtils.cssDsTokenVar(
              statusInSummary.status.color.backgroundToken
            )}
          />
        ))}
    </DataBar.Container>
  );
}
